var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/contactus/solid/icon-aboutus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.9907829,16.0893252 C17.2491068,16.8874875 19.2746309,18.4954197 20.5928769,20.9154125 L20.7727061,21.2454601 C21.6914152,22.931895 20.4894939,25 18.5908284,25 L4.4965819,25 C2.59791644,25 1.39614563,22.931895 2.31485472,21.2454601 L2.49468394,20.9154125 C3.81292991,18.4954197 5.83845397,16.8874875 8.09662738,16.0893252 L11.267039,19.2870147 C11.420082,19.4414238 11.6673283,19.4414238 11.8205218,19.2870147 L14.9907829,16.0893252 Z M27.7255356,11.1682556 C28.6034634,13.684315 27.3055328,16.4462684 24.8264479,17.3374428 C22.7169533,18.0957428 20.4325956,17.2542054 19.2573101,15.4362707 L17.4602218,15.0982812 C17.2651936,15.0616262 17.1824271,14.8244379 17.311242,14.6714033 L18.4981148,13.2607972 C18.2841255,11.0973892 19.5373621,8.98422919 21.6470071,8.22608186 C24.1260921,7.33490746 26.8474574,8.65219609 27.7255356,11.1682556 Z M23.8511565,11.4107894 L22.3138048,11.9137264 L22.3138048,11.999102 L22.4314839,12.0246077 C22.5434445,12.0473644 22.6204927,12.0886012 22.6624779,12.1481656 C22.7044631,12.2078827 22.7253805,12.2973819 22.7253805,12.4168161 L22.7253805,15.0854519 C22.7253805,15.1992351 22.7044631,15.290109 22.6624779,15.3583789 C22.6204927,15.4264961 22.5434445,15.4776603 22.4314839,15.5118716 L22.3138048,15.5457775 L22.3138048,15.6311531 L24.2795865,15.6311531 L24.2795865,15.5457775 L24.195616,15.5202717 C24.0890728,15.4862131 24.0150344,15.4350489 23.9728987,15.3669317 C23.9310639,15.2986618 23.909996,15.207788 23.909996,15.0940048 L23.909996,12.7066959 L23.935127,11.4960122 L23.8511565,11.4107894 Z M11.5437804,5 C14.4222517,5 16.755818,7.36821768 16.755818,10.289773 C16.755818,13.2113282 14.4222517,15.5795459 11.5437804,15.5795459 C8.66515857,15.5795459 6.33174281,13.2113282 6.33174281,10.289773 C6.33174281,7.36821768 8.66515857,5 11.5437804,5 Z M23.3050476,9.66280466 C23.1146844,9.66280466 22.9535153,9.72252174 22.8219917,9.84195591 C22.6903176,9.96123735 22.6245557,10.117632 22.6245557,10.3108343 C22.6245557,10.4985384 22.6903176,10.6534057 22.8219917,10.775589 C22.9535153,10.8977723 23.1146844,10.9588639 23.3050476,10.9588639 C23.4954107,10.9588639 23.655075,10.8977723 23.7840404,10.775589 C23.9127048,10.6534057 23.9772627,10.4985384 23.9772627,10.3108343 C23.9772627,10.117632 23.9127048,9.96123735 23.7840404,9.84195591 C23.655075,9.72252174 23.4954107,9.66280466 23.3050476,9.66280466 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-15.4%",
    y: "-10.0%",
    width: "130.8%",
    height: "140.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/contactus/solid/icon-aboutus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAbout);
export default __webpack_public_path__ + "static/media/icon-about.3272f376b970ce15eed2d820c3b5dd12.svg";
export { ForwardRef as ReactComponent };